import { sanitizeHTML } from '@/lib/utils'

interface SecFaqsProps {
	id: number
	heading?: {
		title?: string
	}
	content_collection?: {
		id: number
		site_content_collections_id: {
			title: string
			collection: {
				item: {
					title?: string // from site_content.title
					text?: string // from site_content.text
				}
			}[]
		}
	}[]
}

export const fields = [
	'heading.title',

	'content_collection.id',
	'content_collection.site_content_collections_id.collection.item:site_content.title',
	'content_collection.site_content_collections_id.collection.item:site_content.text',
]
export default function SecFaqs({ data }: { data: SecFaqsProps }) {
	// Function to calculate text length for an FAQ item
	const calculateFaqTextLength = (faq: any) => {
		const titleItem = faq.site_content_collections_id.collection.find((c: any) => c.item.title)?.item
		const textItem = faq.site_content_collections_id.collection.find((c: any) => c.item.text)?.item
		
		const titleLength = (titleItem?.title || faq.site_content_collections_id.title || '').length
		const textLength = (textItem?.text || '').replace(/<[^>]*>/g, '').length // Remove HTML tags for length calculation
		
		return titleLength + textLength
	}

	// Distribute FAQs more evenly based on text length while preserving order
	const distributeFaqs = () => {
		if (!data?.content_collection) return { leftColumnFaqs: [], rightColumnFaqs: [] }

		const faqs = [...data.content_collection]
		const leftColumn: any[] = []
		const rightColumn: any[] = []
		let leftColumnLength = 0
		let rightColumnLength = 0

		// Distribute each FAQ to the column with less total text, preserving original order
		faqs.forEach(faq => {
			const faqLength = calculateFaqTextLength(faq)
			
			if (leftColumnLength <= rightColumnLength) {
				leftColumn.push(faq)
				leftColumnLength += faqLength
			} else {
				rightColumn.push(faq)
				rightColumnLength += faqLength
			}
		})

		return { leftColumnFaqs: leftColumn, rightColumnFaqs: rightColumn }
	}

	const { leftColumnFaqs, rightColumnFaqs } = distributeFaqs()

	return (
		<section id='faqs' className='SecFaqs py-16 2xl:py-32'>
			<div className='container'>
				<h2 className='text-center mb-12 md:mb-20'>
					{data?.heading?.title || 'Frequently Asked Questions'}
				</h2>

				<div className='grid grid-cols-1 lg:grid-cols-2 gap-12 xl:gap-24'>
					{/* Left Column */}
					<div className='space-y-12'>
						{leftColumnFaqs.map(faq => {
							const titleItem = faq.site_content_collections_id.collection.find(c => c.item.title)?.item
							const textItem = faq.site_content_collections_id.collection.find(c => c.item.text)?.item

							return (
								<div key={faq.id} className='space-y-6'>
									<h3>{titleItem?.title || faq.site_content_collections_id.title || ''}</h3>
									<div
										className='grid gap-8'
										dangerouslySetInnerHTML={sanitizeHTML(textItem?.text || '')}
									/>
								</div>
							)
						})}
					</div>

					{/* Right Column */}
					<div className='space-y-12'>
						{rightColumnFaqs.map(faq => {
							const titleItem = faq.site_content_collections_id.collection.find(c => c.item.title)?.item
							const textItem = faq.site_content_collections_id.collection.find(c => c.item.text)?.item

							return (
								<div key={faq.id} className='space-y-6'>
									<h3>{titleItem?.title || faq.site_content_collections_id.title || ''}</h3>
									<div
										className='grid gap-8'
										dangerouslySetInnerHTML={sanitizeHTML(textItem?.text || '')}
									/>
								</div>
							)
						})}
					</div>
				</div>
			</div>
		</section>
	)
}
